import React, { Component } from 'react'
import packageJSON from '../../../package.json'

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: JSON.parse(window.localStorage.getItem('is_user')) || {},
            appVersion: packageJSON.version || '1.0.0'
        };
    }

    render() {
        return (
            <footer className="main-footer">
                <strong>Copyright &copy; 2020 <a href="https://www.anugrah-argon.com">Anugrah Argon Medica</a>. </strong>
                All rights reserved.
                <div className="float-right d-none d-sm-inline-block"><b>Version</b> {this.state.appVersion}</div>
            </footer>
        )
    }
}

export default Footer